import DashboardAnalytics from '../../components/Dashboard';

const Dashboard = () => {
  return <DashboardAnalytics />;
};

export default Dashboard;
